// dates.ts — local calendar-day helpers (YYYY-MM-DD), shared by the presence,
// capacity-anchor and session-spacing logic. Local time, not UTC, so "today"
// matches the user's day.
export function dayKey(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export const dayKeyOf = (iso: string): string => dayKey(new Date(iso));

/** dayKey for N days before `from` (N>0 = earlier). */
export function dayKeyOffset(n: number, from: Date = new Date()): string {
  return dayKey(new Date(from.getFullYear(), from.getMonth(), from.getDate() - n));
}
